<template>
  <div style="background:#fff;">
    <Top ref="child" />
    <div class="mianbox container">
      <div class="pub clearfix">
        <!-- 左侧内容 -->
        <div class="pub_left" :style="{display:listpubleft}">
          <div class="h1_a">
            <!-- 左侧菜单上的图片 -->
            <img :src="addleftmenusrc()" border="0" />

            <!-- 左侧菜单 -->
            <ul class="left-nav">
              <!-- 添加“推荐”栏目 -->
              <li class="or" v-show="uid4 === '8000'">
                <a>推荐</a>
              </li>
              <li
                v-for="(firstItem) in leftmenusdata.children"
                :key="firstItem.uid"
                :id="firstItem.uid"
                class="nLi"
              >
                <router-link
                  @click.native="showchildren(firstItem.uid)"
                  :to="{path: '/lit/channel', query:{ uid: firstItem.uid}}"
                >{{firstItem.text}}</router-link>
                <span class="arrow"></span>

                <div v-if="firstItem.children.length>0">
                  <ul class="or_a" v-show="uid.indexOf(firstItem.uid) !== -1 && sonCount%2 === 1">
                    <li
                      v-for="secondItem in firstItem.children"
                      :key="secondItem.uid"
                      :id="secondItem.uid"
                      :title="secondItem.text"
                    >
                      <router-link :to="{path: '/lit/channel', query:{ uid: secondItem.uid}}">
                        <strong>·</strong>
                        {{secondItem.text}}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 右侧内容 -->
        <router-view></router-view>
      </div>
    </div>
    <!-- 右侧联系方式  -->
    <rightnav></rightnav>
    <backTop />
    <Footerc />
  </div>
</template>
<script>
import Top from "@/components/top";
import Footerc from "@/components/footerchannel";
import backTop from "@/components/BackTop";
import rightnav from "@/components/rightnav";
import { api } from "@/require/api";
export default {
  name: "list",
  components: {
    Top,
    Footerc,
    rightnav,
    backTop
  },
  data() {
    return {
      uid: "", //url参数
      uid4: "", //4位长度的uid
      country: "",
      city: "",
      uid6: "",
      uidint: 0,

      picDisplay: "none", //右侧联系方式
      phoneDisplay: "none",
      xsDisplay: "none",
      mailDisplay: "none",
      isShow: false, //右侧联系方式中回到顶部

      leftsearch: "none", //项目栏目左侧搜索

      leftmenusdata: [], // 左侧菜单
      listpubleft: "block",

      docListdata: [], //右侧docs
      currentPage: 1,
      pageSizes: [19, 38, 57, 76],
      pageSize: 19,
      total: 0,

      //项目栏目左侧搜索
      selectcountry: "",
      selectsector: "",
      selectamount: "",
      selecttype: "",
      //项目栏目左侧搜索下拉值(写死)
      countrys: [
        {
          name: "所有国家地区",
          value: "所有国家地区"
        },
        {
          name: "阿富汗",
          value: "阿富汗"
        },
        {
          name: "阿联酋",
          value: "阿联酋"
        },
        {
          name: "阿曼",
          value: "阿曼"
        },
        {
          name: "爱沙尼亚",
          value: "爱沙尼亚"
        },
        {
          name: "阿塞拜疆",
          value: "阿塞拜疆"
        },
        {
          name: "阿尔巴尼亚",
          value: "阿尔巴尼亚"
        },
        {
          name: "埃及",
          value: "埃及"
        },
        {
          name: "巴基斯坦",
          value: "巴基斯坦"
        },
        {
          name: "不丹",
          value: "不丹"
        },
        {
          name: "巴林",
          value: "巴林"
        },
        {
          name: "巴勒斯坦",
          value: "巴勒斯坦"
        },
        {
          name: "白俄罗斯",
          value: "白俄罗斯"
        },
        {
          name: "波兰",
          value: "波兰"
        },
        {
          name: "保加利亚",
          value: "保加利亚"
        },
        {
          name: "波黑",
          value: "波黑"
        },
        {
          name: "东帝汶",
          value: "东帝汶"
        },
        {
          name: "俄罗斯",
          value: "俄罗斯"
        },
        {
          name: "菲律宾",
          value: "菲律宾"
        },
        {
          name: "格鲁吉亚",
          value: "格鲁吉亚"
        },
        {
          name: "哈萨克斯坦",
          value: "哈萨克斯坦"
        },
        {
          name: "黑山",
          value: "黑山"
        },

        {
          name: "吉尔吉斯斯坦",
          value: "吉尔吉斯斯坦"
        },

        {
          name: "捷克",
          value: "捷克"
        },
        {
          name: "科威特",
          value: "科威特"
        },

        {
          name: "卡塔尔",
          value: "卡塔尔"
        },

        {
          name: "克罗地亚",
          value: "克罗地亚"
        },

        {
          name: "老挝",
          value: "老挝"
        },

        {
          name: "黎巴嫩",
          value: "黎巴嫩"
        },
        {
          name: "摩洛哥",
          value: "摩洛哥"
        },
        {
          name: "罗马尼亚",
          value: "罗马尼亚"
        },

        {
          name: "拉脱维亚",
          value: "拉脱维亚"
        },

        {
          name: "立陶宛",
          value: "立陶宛"
        },

        {
          name: "蒙古",
          value: "蒙古"
        },

        {
          name: "马来西亚",
          value: "马来西亚"
        },
        {
          name: "缅甸",
          value: "缅甸"
        },
        {
          name: "新西兰",
          value: "新西兰"
        },
        {
          name: "孟加拉国",
          value: "孟加拉国"
        },

        {
          name: "马尔代夫",
          value: "马尔代夫"
        },

        {
          name: "摩尔多瓦",
          value: "摩尔多瓦"
        },

        {
          name: "马其顿",
          value: "马其顿"
        },

        {
          name: "尼泊尔",
          value: "尼泊尔"
        },

        {
          name: "斯里兰卡",
          value: "斯里兰卡"
        },

        {
          name: "沙特",
          value: "沙特"
        },

        {
          name: "泰国",
          value: "泰国"
        },

        {
          name: "斯洛伐克",
          value: "斯洛伐克"
        },

        {
          name: "斯洛文尼亚",
          value: "斯洛文尼亚"
        },

        {
          name: "塞尔维亚",
          value: "塞尔维亚"
        },

        {
          name: "土库曼斯坦",
          value: "土库曼斯坦"
        },

        {
          name: "塔吉克斯坦",
          value: "塔吉克斯坦"
        },

        {
          name: "土耳其",
          value: "土耳其"
        },

        {
          name: "乌兹别克斯坦",
          value: "乌兹别克斯坦"
        },

        {
          name: "乌克兰",
          value: "乌克兰"
        },
        {
          name: "希腊",
          value: "希腊"
        },

        {
          name: "卢森堡",
          value: "卢森堡"
        },
        {
          name: "意大利",
          value: "意大利"
        },
        {
          name: "塞浦路斯",
          value: "塞浦路斯"
        },
        {
          name: "文莱",
          value: "文莱"
        },

        {
          name: "新加坡",
          value: "新加坡"
        },

        {
          name: "叙利亚",
          value: "叙利亚"
        },

        {
          name: "匈牙利",
          value: "匈牙利"
        },

        {
          name: "印度尼西亚",
          value: "印度尼西亚"
        },

        {
          name: "越南",
          value: "越南"
        },

        {
          name: "印度",
          value: "印度"
        },

        {
          name: "以色列",
          value: "以色列"
        },

        {
          name: "伊朗",
          value: "伊朗"
        },

        {
          name: "伊拉克",
          value: "伊拉克"
        },

        {
          name: "约旦",
          value: "约旦"
        },

        {
          name: "也门",
          value: "也门"
        },

        {
          name: "索马里",
          value: "索马里"
        },
        {
          name: "科特迪瓦",
          value: "科特迪瓦"
        },
        {
          name: "塞拉利昂",
          value: "塞拉利昂"
        },
        {
          name: "喀麦隆",
          value: "喀麦隆"
        },
        {
          name: "南苏丹",
          value: "南苏丹"
        },
        {
          name: "塞舌尔",
          value: "塞舌尔"
        },
        {
          name: "几内亚",
          value: "几内亚"
        },
        {
          name: "加纳",
          value: "加纳"
        },
        {
          name: "赞比亚",
          value: "赞比亚"
        },
        {
          name: "莫桑比克",
          value: "莫桑比克"
        },
        {
          name: "加蓬",
          value: "加蓬"
        },
        {
          name: "纳米比亚",
          value: "纳米比亚"
        },
        {
          name: "毛里塔尼亚",
          value: "毛里塔尼亚"
        },
        {
          name: "安哥拉",
          value: "安哥拉"
        },
        {
          name: "吉布提",
          value: "吉布提"
        },
        {
          name: "埃塞俄比亚",
          value: "埃塞俄比亚"
        },
        {
          name: "肯尼亚",
          value: "肯尼亚"
        },
        {
          name: "尼日利亚",
          value: "尼日利亚"
        },
        {
          name: "乍得",
          value: "乍得"
        },
        {
          name: "刚果布",
          value: "刚果布"
        },
        {
          name: "津巴布韦",
          value: "津巴布韦"
        },
        {
          name: "阿尔及利亚",
          value: "阿尔及利亚"
        },
        {
          name: "坦桑尼亚",
          value: "坦桑尼亚"
        },
        {
          name: "布隆迪",
          value: "布隆迪"
        },
        {
          name: "佛得角",
          value: "佛得角"
        },
        {
          name: "乌干达",
          value: "乌干达"
        },
        {
          name: "冈比亚",
          value: "冈比亚"
        },
        {
          name: "多哥",
          value: "多哥"
        },
        {
          name: "南非",
          value: "南非"
        },
        {
          name: "苏丹",
          value: "苏丹"
        },
        {
          name: "马达加斯加",
          value: "马达加斯加"
        },
        {
          name: "突尼斯",
          value: "突尼斯"
        },
        {
          name: "利比亚",
          value: "利比亚"
        },
        {
          name: "塞内加尔",
          value: "塞内加尔"
        },
        {
          name: "卢旺达",
          value: "卢旺达"
        },
        {
          name: "赤道几内亚",
          value: "赤道几内亚"
        },
        {
          name: "利比里亚",
          value: "利比里亚"
        },
        {
          name: "安提瓜和巴布达",
          value: "安提瓜和巴布达"
        },
        {
          name: "巴拿马",
          value: "巴拿马"
        },
        {
          name: "特立尼达和多巴哥",
          value: "特立尼达和多巴哥"
        },
        {
          name: "玻利维亚",
          value: "玻利维亚"
        },
        {
          name: "哥斯达黎加",
          value: "哥斯达黎加"
        },
        {
          name: "乌拉圭",
          value: "乌拉圭"
        },
        {
          name: "圭亚那",
          value: "圭亚那"
        },
        {
          name: "苏里南",
          value: "苏里南"
        },
        {
          name: "委内瑞拉",
          value: "委内瑞拉"
        },
        {
          name: "秘鲁",
          value: "秘鲁"
        },
        {
          name: "厄瓜多尔",
          value: "厄瓜多尔"
        },
        {
          name: "巴布亚新几内亚",
          value: "巴布亚新几内亚"
        },
        {
          name: "多米尼克",
          value: "多米尼克"
        },
        {
          name: "纽埃",
          value: "纽埃"
        },
        {
          name: "格林纳达",
          value: "格林纳达"
        },
        {
          name: "牙买加",
          value: "牙买加"
        },
        {
          name: "巴巴多斯",
          value: "巴巴多斯"
        },
        {
          name: "亚美尼亚",
          value: "亚美尼亚"
        },
        {
          name: "奥地利",
          value: "奥地利"
        },
        {
          name: "柬埔寨",
          value: "柬埔寨"
        }
      ],
      sectors: [
        { name: "所有行业", value: "所有行业" },
        { name: "农业", value: "农业" },
        { name: "能源矿产", value: "能源矿产" },
        { name: "信息通信", value: "信息通信" },
        { name: "基础设施", value: "基础设施" },
        { name: "制造业", value: "制造业" },
        { name: "服务业", value: "服务业" }
      ],
      sector: "",
      amounts: [
        { name: "所有金额", value: "所有金额" },
        { name: "0-1000万美元", value: "0-1000万美元" },
        { name: "1000万—5000万美元", value: "1000万—5000万美元" },
        { name: "5000万-1亿美元", value: "5000万-1亿美元" },
        { name: "1亿美元以上", value: "1亿美元以上" }
      ],
      amount: "",
      types: [
        { name: "所有项目类型", value: "所有项目类型" },
        { name: "股权投资", value: "股权投资" },
        { name: "绿地投资", value: "绿地投资" },
        { name: "融资租赁", value: "融资租赁" },
        { name: "债权投资", value: "债权投资" },
        { name: "其它投资", value: "其它投资" }
      ],
      type: "",
      sonCount: 1,
      sonCurrent: ''
    };
  },
  created() {
    this.uid = this.$route.query.uid;
    this.uid4 = this.uid.toString().substring(0, 4);
    this.uid6 = this.uid.toString().substring(0, 6);
    this.country = this.$route.query.country;
    this.city = this.$route.query.city;
    //项目栏目左侧搜索
    // 添加“推荐”栏目，特殊处理
    if (this.uid4.indexOf("8000") !== -1) {
    } else {
      if (this.uid4.indexOf("8008") !== -1) {
        this.listpubleft = "none";
      } else {
        this.listpubleft = "block";
        this.loadLeftmenus(); // 左侧菜单接口
      }

      this.addleftmenusrc(); //左侧菜单上边图片
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.scrollToTop); //右侧联系方式-回到顶部
    // 顶部查询显示
    this.$refs.child.isShowsearch = true;
    this.$refs.child.ischannelright = true;

    //左侧菜单样式
    if (this.uid4.indexOf("8000") === -1) {
      setTimeout(() => {
        this.setleftmenustyle();
      }, 100);
    }
  },
  methods: {
    //左侧菜单上边图片
    addleftmenusrc() {
      try {
        let yqinfoimgs = require("../../assets/imgs/UID/" + this.uid4 + ".gif");
        return yqinfoimgs;
      } catch (err) {
        let yqinfeorrorimg = require("../../assets/imgs/UID/default.gif");
        return yqinfeorrorimg;
      }
    },
    //根据uid长度给不同样式
    setleftmenustyle() {
      this.uid = this.$route.query.uid;

      //4位时给所有li赋nLi
      if (this.uid.length == 4) {
        $(".left-nav li")
          .removeClass("or")
          .addClass("nLi");

        //儿子们li不加nLi
        $(".or_a li").removeClass("nLi");

        //儿子们的样式变为黑色
        $(".or_a")
          .find("a")
          .css("color", "#000");
        $(".or_a")
          .find("strong")
          .css("color", "#000");
      }
      //6位时给相应的li赋or，其它是nLi
      if (this.uid.length == 6) {
        $("#" + this.uid)
          .removeClass("nLi")
          .addClass("or")
          .siblings()
          .removeClass("or")
          .addClass("nLi");
        //儿子们的样式变为黑色
        $(".or_a")
          .find("a")
          .css("color", "#000");
        $(".or_a")
          .find("strong")
          .css("color", "#000");
      }
      //儿子们
      if (this.uid.length == 8) {
        this.uid6 = this.uid.toString().substring(0, 6);
        $("#" + this.uid6)
          .removeClass("nLi")
          .addClass("or");
        $("#" + this.uid6)
          .siblings()
          .removeClass("or")
          .addClass("nLi");
        //资讯栏目需要把其它儿子们设置为黑色
        $(".or_a")
          .find("a")
          .css("color", "#000");
        //a标签
        $("#" + this.uid)
          .find("a")
          .css("color", "#1C4199");
        $("#" + this.uid)
          .siblings()
          .find("a")
          .css("color", "#000");
        //strong标签
        $("#" + this.uid)
          .find("strong")
          .css("color", "#1C4199");
        $("#" + this.uid)
          .siblings()
          .find("strong")
          .css("color", "#000");
      }
    },
    //左侧菜单儿子显示隐藏
    showchildren(val) {
      if (this.sonCurrent === val) {
        this.sonCount = this.sonCount + 1
      }else{
        this.sonCurrent = val
        this.sonCount = 1
      }
      this.uid = this.$route.query.uid;
      $("#" + this.uid + " div .or_a").toggleClass("or_a_isshow");
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    //项目栏目显示左侧搜索
    showSearch(uid) {
      this.leftsearch = "block";
    },
    // 左侧菜单接口
    async loadLeftmenus() {
      const { code, data } = await api.get(
        "/documentController/getWebChannel",
        {
          uid: this.uid4
        }
      );
      if (code === 0) {
        this.leftmenusdata = data;
      }
    },
    //项目栏目-搜索-改变下拉值
    countryinput(value) {
      this.selectcountry = value;
    },
    sectorinput(value) {
      this.selectsector = value;
    },
    amountinput(value) {
      this.selectamount = value;
    },
    typeinput(value) {
      this.selecttype = value;
    },
    //项目栏目-搜索-确定
    async projectsearch() {
      let searchparam = "";
      if (this.selectcountry != "" && this.selectcountry != "所有国家地区") {
        searchparam += `${this.selectcountry},`;
      }
      if (this.selectsector != "" && this.selectsector != "所有行业") {
        searchparam += `${this.selectsector},`;
      }
      if (this.selectamount != "" && this.selectamount != "所有金额") {
        searchparam += `${this.selectamount},`;
      }
      if (this.selecttype != "" && this.selecttype != "所有项目类型") {
        searchparam += `${this.selecttype},`;
      }
      searchparam = searchparam.substring(0, searchparam.lastIndexOf(","));

      const { code, data } = await api.get(
        "/documentController/getPageChannelDocumentsByUId",
        {
          uid: this.uid,
          curPage: this.currentPage,
          pageSize: this.pageSize,
          attr: searchparam
        }
      );
      if (code === 0) {
        this.total = data.totlalCount;
        this.docListdata = data.data;
      }
    },
    //右侧联系方式-回到顶部是否显示
    scrollToTop() {
      if (document.documentElement.scrollTop > 100) {
        this.isShow = true;
      } else if (document.documentElement.scrollTop < 100) {
        this.isShow = false;
      }
    },
    //右侧联系方式-回到顶部
    backTop() {
      let timer = setInterval(() => {
        let top = document.documentElement.scrollTop;
        let speed = Math.ceil(top / 5);
        document.documentElement.scrollTop = top - speed;
        if (top === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    //右侧联系方式-鼠标移上显示对应的
    secondShow(num) {
      if (num === 1) {
        this.picDisplay = "block";
      } else if (num === 2) {
        this.phoneDisplay = "block";
      } else if (num === 3) {
        this.xsDisplay = "block";
      } else if (num === 4) {
        this.mailDisplay = "block";
      }
    },
    //右侧联系方式-鼠标移开隐藏对应的
    secondHide(num) {
      if (num === 1) {
        this.picDisplay = "none";
      } else if (num === 2) {
        this.phoneDisplay = "none";
      } else if (num === 3) {
        this.xsDisplay = "none";
      } else if (num === 4) {
        this.mailDisplay = "none";
      }
    }
  },
  computed: {},
  watch: {
    selectcountry: function(a, b) {},
    leftmenusdata: function() {
      this.$nextTick(function() {
        this.uid = this.$route.query.uid;
      });
    },
    $route: function() {
      this.uid = this.$route.query.uid;
      this.uid4 = this.uid.toString().substring(0, 4);
      this.uid6 = this.uid.toString().substring(0, 6);
      // 添加“推荐”栏目，特殊处理
      if (this.uid4.indexOf("8000") === -1) {
        if (this.uid4.indexOf("8008") !== -1) {
          this.listpubleft = "none";
        } else {
          this.listpubleft = "block";
          this.loadLeftmenus();
        }

        this.addleftmenusrc();
        this.setleftmenustyle();
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop); //右侧联系方式-回到顶部
  }
};
</script>

<style lang='less' scoped>
/deep/.guides {
  display: none !important;
}
.header_bj {
  background: url(../../assets/imgs/navtop2.jpg) no-repeat !important;
  background-size: 100% 100% !important;
}
/deep/.header {
  width: 1200px !important;
  margin: 0 auto !important;
}
img {
  border: 0;
  vertical-align: middle;
  display: inline-block;
}
a {
  text-decoration: none;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}

/* font */
.fB {
  font-weight: bold;
}
.red1 {
  color: #c81623;
}
.yellow1 {
  color: #ff0;
}
.h_1 {
  color: #333;
}

/* float */
.clear {
  clear: both;
  display: block;
}
.f12 {
  font-size: 12px;
}
.f15 {
  font-size: 15px;
}
.f19 {
  font-size: 19px;
}
/* margin */
.mb10 {
  margin-bottom: 10px;
}
.mt10 {
  margin-top: 10px;
}
.pt10 {
  padding-top: 10px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.tright {
  text-align: right;
}

.lft {
  float: left;
}
.rgt {
  float: right;
  display: inline;
}
.clear {
  clear: both;
  display: block;
}

/*----------nav----------*/
.header_bottom {
  font-family: "Microsoft Yahei", "微软雅黑", Tahoma, Arial, Helvetica, STHeiti;
  text-align: center;
  height: 42px;
  background: url(../../assets/imgs/nav.gif) no-repeat center;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}

#substation .header_bottom .nav .subnav {
  margin: 0 16px;
}

/*-------main------------*/
.mianbox {
  background-color: #fff;
  margin-top: 10px;
  padding-top: 2px;
}
.hot {
  margin: 10px 10px 0px;
  width: 1210px;
  height: 358px;
}
.slideBox {
  position: relative;
  float: left;
  margin: 10px 0;
  overflow: hidden;
  width: 661px;
  height: 338px;
  font-size: 0;
}
.slideBox .bd {
  height: 100%;
}
.slideBox .txtbg {
  width: 100%;
  height: 40px;
  left: 0;
  bottom: 0;
  background: #000;
  color: white;
  position: absolute;
  filter: Alpha(opacity=70);
  -moz-opacity: 0.7;
  opacity: 0.7;
  z-index: 99;
}
.slideBox .num {
  height: 10px;
  position: absolute;
  z-index: 9999;
  bottom: 16px;
  right: 0px;
}
.slideBox .num .on {
  background: #0b7ed1;
}
.slideBox .num span {
  background: #999;
  display: block;
  width: 20px;
  height: 11px;
  margin-right: 12px;
  cursor: pointer;
  float: left;
}
.slideBox h2 {
  position: absolute;
  width: 661px;
  height: 40px;
  line-height: 39px;
  font-size: 16px;
  color: #fff;
  bottom: 0;
  padding: 0 85px 0 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  z-index: 100;
}

.hot_spot {
  position: relative;
  float: right;
  width: 520px;
  height: 338px;
  padding: 0px 10px 0px 10px;
  border-bottom: #ccc 1px solid;
  border-right: #ccc 1px solid;
  background: url(../../assets/imgs/tu2.gif) right bottom no-repeat;
  margin-top: 10px;
}
.hot_spot .img1 {
  margin-bottom: 10px;
}
.hot_spot h3 {
  line-height: 35px;
  font-size: 18px;
  font-family: "微软雅黑", "Microsoft YaHei";
  font-weight: bold;
}
.hot_spot ul li {
  line-height: 35px;
}
.hot_spot ul li a {
  color: #333;
  text-decoration: none;
}
.hot_spot ul li a:hover {
  color: #c00;
}
.hot_spot ul li img {
  z-index: -1;
}
.hot_spot .briefly {
  color: #888;
  font-size: 13px;
  white-space: normal;
  padding-left: 5px;
  padding-top: 5px;
  line-height: 25px;
  margin: 0 0 2px;
  text-indent: 2em;
  border-bottom: 1px dashed #ccc;
  height: 80px;
}

/* -------left-----------*/
.container_left {
  float: left;
  width: 824px;
}
.list_report {
  width: 824px;
  padding: 5px 10px 0px;
}
.list_main {
  width: 400px;
  padding: 10px 0px;
}
.list_report .lest_a {
  border: #ccc solid 1px;
}
.list_content {
  margin-top: 10px;
}
.list_content .title {
  margin-bottom: 6px;
  height: 103px;
}
.list_content .title .img1 {
  border: #ccc 1px solid;
  padding: 1px;
  float: left;
  margin-right: 10px;
  width: 119px;
  height: 74px;
}
.list_content .title h3 {
  padding-bottom: 5px;
  border-bottom: 1px dashed #ccc;
  font-size: 14px;
  color: #9b1111;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 44px;
  *height: 50px;
  *float: right;
  *width: 265px;
}
.list_content .title h3 a {
  color: #115bac;
}
.list_content .title h3 a:hover {
  color: #c00;
  text-decoration: none;
}
.list_content .title .briefly {
  padding-left: 10px;
  font-size: 12px;
  color: #888;
  margin-top: 5px;
}

.list_content .list_article li {
  list-style-type: none;
}
.list_content .list_article li a {
  color: #333;
  height: 33px;
  line-height: 33px;
  text-decoration: none;
}
.list_content .list_article li a:hover {
  color: #c00;
}
/*----------right-----------*/
.container_right {
  width: 370px;
  float: right;
  margin-right: 10px;
  margin-top: 0px;
}
.container_right .gb {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
  height: 185px;
}
.container_right .gb .zm {
  margin-top: 10px;
}
.container_right .gb .zm ul li {
  float: left;
  line-height: 30px;
  padding-left: 5px;
  text-align: center;
  margin-bottom: 10px;
}
.container_right .gb .zm .region1 {
  display: block;
  background: #cd3333;
  font-size: 18px;
  width: 83px;
  color: #fff;
}
.container_right .gb .zm .region {
  display: block;
  font-size: 18px;
  width: 83px;
  color: #333;
  background: #e6e6e6;
  text-decoration: none;
  display: block;
}

.countries_a {
  width: 350px;
  margin: 0 10px;
}
.countries_a a {
  right: 10px;
  padding-right: 15px;
  color: #333;
  line-height: 27px;
  text-decoration: none;
}
.countries_a a:hover {
  color: #c00;
}

.container_right .gh {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
}
.title_a {
  margin: 10px 0;
}
.title_a ul li {
  padding-left: 10px;
  line-height: 30px;
}
.title_a ul li a {
  color: #333;
  text-decoration: none;
}
.title_a ul li a:hover {
  color: #c00;
}
.title_a h3 {
  height: 30px;
  line-height: 30px;
  background-color: #e6e6e6;
  padding-left: 10px;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
}
.title_a .more_b {
  text-align: right;
  margin-right: 10px;
}

.demo1 {
  float: left;
  clear: both;
  width: 1220px;
  height: 260px;
  overflow: hidden;
  background-color: #fff;
  margin: 10px auto;
  border: 1px #e7e7e7 solid;
}
.inside {
  position: relative;
  top: 110px;
  left: 0;
  height: 150px;
  margin-top: -75px;
  width: 1220px;
}
.demo1 .insidetext {
  position: relative;
  top: 10%;
  left: 0;
  width: 1220px;
}
.demo1 .insidetext .text {
  text-align: center;
  width: 130px;
}

.demo1 .num {
  height: 10px;
  z-index: 9999;
  width: 200px;
  margin-top: 160px;
  margin-left: 1080px;
}
.demo1 .num .on {
  background: #0b7ed1;
}
.demo1 .num span {
  background: #999;
  display: block;
  width: 20px;
  height: 11px;
  margin-right: 12px;
  cursor: pointer;
  float: left;
}

.demo1 .inside .inside_t1 {
  z-index: 1;
  width: 135px;
  height: 135px;
  display: block;
}
.demo1 .inside .inside_t2 {
  top: -20px;
  z-index: 10;
  width: 190px;
  height: 190px;
  display: block;
  margin-left: -30px;
  margin-top: 0px;
}
.demo1 a {
  display: block;
  position: absolute;
  width: 130px;
  height: 130px;
  overflow: hidden;
  border: 3px solid #fff;
  -moz-border-radius: 150px;
  -webkit-border-radius: 150px;
  border-radius: 150px;
}
.scroller .active {
  z-index: 5 !important;
}

.demo1 .inside .inside_tt {
  text-align: center;
  position: absolute;
  width: 135px;
}
.demo1 .inside .inside_tt .zz {
  position: relative;
}

/*测试国家小图变大图*/
.demo2 li {
  float: left;
  text-align: center;
  cursor: pointer;
  z-index: 0;
  position: relative;
  margin: 0px -20px 10px 0px;
  width: 130px;
  height: 130px;
}
.demo2 li .r {
  margin-right: 0;
}
.demo2 li .in img {
  *width: 130px;
  *height: auto;
}
.demo2 li .in {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 130px;
}
.demo2 li .in .imgdiv {
  display: block;
  width: 130px;
  height: 130px;
  margin: 0 auto;
  margin-top: 4px;
  overflow: hidden;
}
.demo2 li span {
  display: block;
  text-align: center;
  height: 36px;
  padding: 8px 3px 0 3px;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.demo2 li .b1 {
  display: block;
  color: #333;
}
.demo2 li .b2 {
  display: block;
  color: #0065b9;
  font-weight: bold;
}
.demo2 li.pic .original {
  display: none;
  padding: 5px;
  padding-bottom: 0;
  position: absolute;
  text-align: center;
  left: -16px;
  top: -59px;
}
.demo2 li.pic .original .imga {
  display: block;
}
.demo2 li .original img {
  *height: 130px;
  *width: auto;
}
.demo2 li .original span {
  height: 36px;
  padding-top: 0;
}
.demo2 li .original b {
  line-height: 36px;
}
.demo2 li.on {
  z-index: 99;
}
.demo2 li.on .original {
  display: block;
  z-index: 100;
}

/* float */
.slide_country {
  position: relative;
  z-index: 0;
  width: 1220px;
  background: #fff;
  height: 278px;
  overflow: hidden;
}
.slide_country .box {
  overflow: hidden;
  position: relative;
  width: 1220px;
  height: 278px;
}

.slide_country .btn {
  overflow: hidden;
  position: absolute;
  bottom: 25px;
  right: 15px;
  z-index: 10;
}
.slide_country .btn li {
  float: left;
  width: 20px;
  height: 15px;
  margin: 0 0 0 10px;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
  background: #525252;
  color: #fff;
  line-height: 18px;
  border: 1px solid #434343;
  text-align: center;
  cursor: pointer;
}
.slide_country .btn .selected {
  background: #0b7ed1;
  border-color: #0b7ed1;
}
// .slide_country .minus,.slide_country .plus{position:absolute;top:110px; width:30px; height:75px; background:url(../../assets/imgs/slider_bn_bg.png) no-repeat 0 0; text-align:center;cursor:pointer;}
.slide_country .minus,
.slide_country .plus {
  position: absolute;
  top: 110px;
  width: 30px;
  height: 75px;
  text-align: center;
  cursor: pointer;
}
.slide_country .minus {
  left: 0;
  background-position: 0 0;
}
.slide_country .plus {
  right: 0;
  background-position: 0px -75px;
}
.slide_country .minus:hover {
  background-position: -30px 0px;
}
.slide_country .plus:hover {
  background-position: -30px -75px;
}

.container_right .zj {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
  padding-bottom: 10px;
}
.container_right .zj img {
  margin-bottom: 10px;
}
.container_right .zj .zt_imglist {
  height: 42px;
  margin-top: 12px;
}
.container_right .zj .zt_imglist strong {
  background-color: #cd3333;
  color: #fff;
  font-size: 15px;
  float: left;
  width: 58px;
  height: 31px;
  line-height: 31px;
  text-align: center;
  margin-left: 15px;
}
.container_right .zj .zt_imglist a {
  display: block;
  background: transparent url("../../assets/imgs/line2.jpg") no-repeat scroll 0%
    0%;
  width: 260px;
  height: 31px;
  line-height: 31px;
  float: left;
  padding-left: 20px;
  color: #333;
  float: right;
}
.container_right .zj .zt_imglist a:hover {
  color: #cd3333;
  text-decoration: none;
}

.container_right .dsj {
  border-top: none;
  border: #e7e7e7 1px solid;
  border-top: none;
  padding-bottom: 10px;
}
.textdricon {
  background: url(../../assets/imgs/line1.jpg) repeat-y 102px top;
  padding-bottom: 20px;
}
.textdricon strong {
  display: block;
  width: 100px;
  float: left;
  background: url(../../assets/imgs/icon2.png) no-repeat right center;
  height: 30px;
  line-height: 30px;
  color: #500d08;
  font-size: 13px;
}
.textdricon .point1 {
  background: url(../../assets/imgs/icon2.png) no-repeat right center;
}
.textdricon .point2 {
  background: url(../../assets/imgs/icon3.png) no-repeat right center;
}
.textdricon .point3 {
  background: url(../../assets/imgs/icon4.png) no-repeat right center;
}
.textdricon .point4 {
  background: url(../../assets/imgs/icon5.png) no-repeat right center;
}
.textdricon .point5 {
  background: url(../../assets/imgs/icon6.png) no-repeat right center;
}
.textdricon .point6 {
  background: url(../../assets/imgs/icon7.png) no-repeat right center;
}
.textdricon .point7 {
  background: url(../../assets/imgs/icon8.png) no-repeat right center;
}
.textdricon .point8 {
  background: url(../../assets/imgs/icon9.png) no-repeat right center;
}
.textdricon a {
  width: 220px;
  padding: 5px;
  color: #500d08;
}
.textdricon li {
  padding-left: 10px;
  margin-top: 20px;
  height: 70px;
}
.textdricon .mCon_Cutbtn {
  background: #ecf6ff;
  border-bottom: 2px #0065b8 solid;
}

.jg_box .jg_a {
  width: 823px;
  float: left;
  margin-top: 20px;
}
.jg_box .jg_a li {
  float: left;
  background: #fff none repeat scroll 0% 0%;
  border: 1px solid #e4e4e4;
  display: inline-block;
  height: 108px;
  margin-bottom: 14px;
  text-align: center;
  width: 120px;
  margin-left: 7px;
  *margin-left: 13px;
}
.jg_box .jg_a li a {
  background: transparent url(../../assets/imgs/icon1.png) no-repeat scroll 0px
    0px;
  display: inline-block;
  height: 50px;
  margin-top: 17px;
  overflow: hidden;
  width: 50px;
}
.jg_box .jg_a li p {
  font-weight: bold;
  font-size: 13px;
}
.jg_box .jg_a li .c1 {
  background-position: 0px 0px;
}
.jg_box .jg_a li .c2 {
  background-position: 0px -59px;
}
.jg_box .jg_a li .c3 {
  background-position: 0px -118px;
}
.jg_box .jg_a li .c4 {
  background-position: 0px -177px;
}
.jg_box .jg_a li .c5 {
  background-position: 0px -236px;
}
.jg_box .jg_a li .c6 {
  background-position: 0px -295px;
}
.jg_box .jg_a li .c7 {
  background-position: 0px -354px;
}
.jg_box .jg_a li .c8 {
  background-position: 0px -413px;
}
.jg_box .jg_a li .c9 {
  background-position: 0px -472px;
}
.jg_box .jg_a li .c1:hover {
  background-position: -73px -0px;
}
.jg_box .jg_a li .c2:hover {
  background-position: -73px -59px;
}
.jg_box .jg_a li .c3:hover {
  background-position: -73px -118px;
}
.jg_box .jg_a li .c4:hover {
  background-position: -73px -177px;
}
.jg_box .jg_a li .c5:hover {
  background-position: -73px -236px;
}
.jg_box .jg_a li .c6:hover {
  background-position: -73px -295px;
}
.jg_box .jg_a li .c7:hover {
  background-position: -73px -354px;
}
.jg_box .jg_a li .c8:hover {
  background-position: -73px -413px;
}
.jg_box .jg_a li .c9:hover {
  background-position: -73px -472px;
}

.link_a {
  width: 1230px;
}
.link_a .link_b {
  background-color: #e7e7e7;
  margin: 20px 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.link_a .link_b {
  text-align: center;
}
.link_a .link_b .link_c {
  padding: 10px;
}

.bottom_box {
  position: relative;
  text-align: center;
  overflow: hidden;
}
.homebottom {
  margin: 30px 0;
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 32%;
}

.current {
  background-color: #1c4199;
}

/*banner*/
.bannerwrap {
  width: 661px;
  overflow: hidden;
  height: 338px;
  position: relative;
  margin: 10px 0px;
  top: -1px;
  float: left;
}
.bannerwrap .imgTitle {
  overflow: hidden;
  position: absolute;
  text-align: left;
  width: 661px;
  z-index: 1;
  height: 40px;
  bottom: 50px;
  line-height: 40px;
  *left: 0;
}
.bannerwrap .imgTitle .bg {
  position: absolute;
  z-index: -1;
  height: 180px;
  background: #252525;
  filter: alpha(opacity=60);
  opacity: 0.5;
  width: 100%;
  top: 0;
}
.bannerwrap .imgTitle .txt {
  line-height: 22px;
  padding: 10px;
}
.bannerwrap .imgTitle .t1 {
  background: #495767;
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
}
.bannerwrap h2 {
  position: absolute;
  width: 661px;
  height: 40px;
  line-height: 39px;
  font-size: 16px;
  color: #fff;
  bottom: 0;
  padding: 0 85px 0 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  z-index: 100;
}
/* float */
.slide_x {
  position: relative;
  z-index: 0;
  width: 661px;
  background: #fff;
  height: 338px;
  overflow: hidden;
}
.slide_x .box {
  overflow: hidden;
  position: relative;
  width: 661px;
  height: 338px;
}
.slide_x .list {
  overflow: hidden;
  width: 9999px;
  z-index: 1;
}
.slide_x .list li {
  float: left;
  position: relative;
  width: 661px;
}
.slide_x .list img {
  vertical-align: top;
  width: 661px;
  height: 390px;
}
.slide_x .btn {
  overflow: hidden;
  position: absolute;
  bottom: 10px;
  right: 15px;
  z-index: 10;
}
.slide_x .btn li {
  float: left;
  width: 20px;
  height: 15px;
  margin: 0 0 0 10px;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
  background: #525252;
  color: #fff;
  line-height: 18px;
  border: 1px solid #434343;
  text-align: center;
  cursor: pointer;
}
.slide_x .btn .selected {
  background: #0b7ed1;
  border-color: #0b7ed1;
}
// .slide_x .minus,.slide_x .plus{position:absolute;top:110px; width:30px; height:75px; background:url(../../assets/imgs/slider_bn_bg.png) no-repeat 0 0; text-align:center;cursor:pointer;}
.slide_x .minus,
.slide_x .plus {
  position: absolute;
  top: 110px;
  width: 30px;
  height: 75px;
  text-align: center;
  cursor: pointer;
}
.slide_x .minus {
  left: 0;
  background-position: 0 0;
}
.slide_x .plus {
  right: 0;
  background-position: 0px -75px;
}
.slide_x .minus:hover {
  background-position: -30px 0px;
}
.slide_x .plus:hover {
  background-position: -30px -75px;
}

#login-form a {
  font-family: "ËÎÌå";
  font-size: 12px;
  color: #ff5336;
  text-decoration: none;
  font-weight: bold;
}

/* 浮动工具条*/
// .izl-rmenu{position:fixed;right:0;bottom:10px;padding-bottom:73px;background:url(../../assets/imgs/r_b.png) 0px bottom no-repeat;z-index:999;}
.izl-rmenu {
  position: fixed;
  right: 0;
  bottom: 10px;
  padding-bottom: 73px;
  z-index: 999;
}
.izl-rmenu .btn {
  width: 72px;
  height: 73px;
  margin-bottom: 1px;
  cursor: pointer;
  position: relative;
}
.izl-rmenu .btn-wx {
  background: url(../../assets/imgs/r_wx.png) 0px 0px no-repeat;
  background-color: #78c340;
}
.izl-rmenu .btn-wx:hover {
  background-color: #58a81c;
}
.izl-rmenu .btn-wx .pic {
  position: absolute;
  left: -160px;
  top: 0px;
  width: 160px;
  height: 160px;
  display: none;
}
.izl-rmenu .btn-phone {
  background: url(../../assets/imgs/r_phone.png) 0px 0px no-repeat;
  background-color: #fbb01f;
}
.izl-rmenu .btn-phone:hover {
  background-color: #ff811b;
}
.izl-rmenu .btn-phone .phone {
  background-color: #ff811b;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-xs {
  background: url(../../assets/imgs/r_xs.png) 0px 0px no-repeat;
  background-color: #6cafeb;
}
.izl-rmenu .btn-xs:hover {
  background-color: #5d9fdb;
}
.izl-rmenu .btn-xs .xs {
  background-color: #5d9fdb;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.izl-rmenu .btn-mail {
  background: url(../../assets/imgs/r_mail.png) 0px 0px no-repeat;
  background-color: #e37677;
}
.izl-rmenu .btn-mail:hover {
  background-color: #dd6364;
}
.izl-rmenu .btn-mail .mail {
  background-color: #dd6364;
  position: absolute;
  width: 160px;
  left: -160px;
  top: 0px;
  line-height: 73px;
  color: #fff;
  font-size: 15px;
  text-align: center;
}

.izl-rmenu .btn-top {
  background: url(../../assets/imgs/r_top.png) 0px 0px no-repeat;
  background-color: #666666;
}
.izl-rmenu .btn-top:hover {
  background-color: #444;
}

.pagingsite {
  margin-right: 10px;
  padding-top: 10px;
}
.pagingsite {
  clear: both;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: normal;
  height: 1%;
  overflow: hidden;
}

//.mianbox .menu_2{ background:url(../../assets/imgs/a2.gif) no-repeat center; height:30px; width:240px; }
.mianbox .menu_2 {
  height: 30px;
  width: 240px;
}

// channel.css
.mianbox .pub_left {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 305px;
  text-align: center;
  background: url(../../assets/imgs/img_bj.gif) repeat-y top;
  height: 1350px;
}

.mianbox .pub_left .h1_a {
  width: 305px;
  height: 45px;
  background: url(../../assets/imgs/img_bj2.gif) no-repeat top;
  height: 161px;
  font-size: 18px;
  line-height: 38px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 500;
}
.mianbox .pub_left .left-nav {
  *width: 282px;
  padding: 0 0px 25px 0px;
  *padding: 0;
  text-align: center;
}
.mianbox .pub_left .left-nav .or {
  position: relative;
  margin-bottom: 10px;
  line-height: 40px;
  font-size: 16px;
  margin-right: 10px;
  text-align: left;
  // height: 40px;
  background-color: #193d8a;
}
.mianbox .pub_left .left-nav .or h3 {
  height: 40px;
  background-color: #185bb0;
}
.mianbox .pub_left .left-nav .or .or_a a {
  color: #333;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}

.mianbox .pub_left .left-nav .or a {
  color: #fff;
  margin-left: 60px;
}

.mianbox .pub_left .left-nav .or .arrow {
  color: #fff;
  float: right;
  font-size: 18px;
  padding-right: 40px;
  background: url(../../assets/imgs/icon_a.png) no-repeat center;
}

.mianbox .pub_left .left-nav .nLi {
  position: relative;
  margin-bottom: 10px;
  line-height: 40px;
  font-size: 16px;
  margin-right: 10px;
  text-align: left;
  // height: 40px;
  background-color: #fff;
}
.mianbox .pub_left .left-nav .nLi h3 {
  height: 40px;
  background-color: #fff;
}
.mianbox .pub_left .left-nav .nLi .or_a a {
  color: #333;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}

.mianbox .pub_left .left-nav .nLi a {
  color: #193d8a;
  position: relative;
  padding-left: 60px;
}
.mianbox .pub_left .left-nav .nLi .arrow {
  color: #193d8a;
  float: right;
  font-size: 18px;
  padding-right: 40px;
  height: 40px;
  background: url(../../assets/imgs/icon2.gif) no-repeat center;
}

/*给国别页法规设置*/
.ultext li .sub1 {
  float: left;
  width: 500px;
  height: 33px;
  text-align: left;
  color: #1c4199;
  font-size: 16px;
  padding-left: 10px;
  padding-top: 10px;
}
.ultext li .date1 {
  float: right;
  height: 23px;
  color: #808080;
  font-size: 12px;
  padding-right: 10px;
  padding-top: 10px;
}

.mianbox .pub {
  //margin: 0 3.5%;
  //padding-top: 4%;
}
.position {
  background: #ebebeb url(../../assets/imgs/icon_li.png) no-repeat scroll 18px;
  font-size: 15px;
  line-height: 30px;
  padding-left: 30px;
  padding-top: 2px;
}
.pub_left1 {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 738px;
}
.pub_left1 .left-gj {
  margin-top: 15px;
}
.pub_left1 .left-gj .letter {
  text-align: left;
  width: 738px;
  z-index: 100;
  height: 50px;
}
.pub_left1 .left-gj .letter ul li {
  float: left;
  line-height: 50px;
  width: 38px;
  *width: 21px;
}
.pub_left2 .left-gj .letter a {
  cursor: pointer;
}
.pub_left1 .left-gj .letter .card {
  background: url(../../assets/imgs/tu7.gif) no-repeat bottom;
  position: relative;
  height: 14px;
  width: 16px;
  clear: both;
  bottom: 13px;
  *bottom: 12px;
  padding-left: 40px;
}
.pub_left1 .left-gj .letter a {
  padding-left: 23px;
  font-size: 17px;
  color: #333;
}
.pub_left1 .left-gj .letter a:hover {
  color: #c33;
}

.pub_left1 .left-gj .gq {
  height: 150px;
  width: 100%;
  border: #c4dcf1 2px solid;
}
.pub_left1 .left-gj .ss {
  border: #c4dcf1 2px solid;
  padding: 10px 10px 10px 20px;
  *height: 120px;
}
.pub_left1 .left-gj .ss a {
  color: #333;
  font-weight: bold;
  font-size: 15px;
  width: 62px;
  height: 30px;
  line-height: 30px;
  display: block;
  float: left;
  text-align: center;
}
.pub_left1 .left-gj .ss .asel {
  color: #fff;
  background-color: #3162be;
}

.pub_left1 .left-gj .ss a:hover {
  color: #c00;
}
.pub_left1 .left-gj .gq img {
  border: #ebebeb 1px solid;
}
.pub_left1 .left-gj .gq ul {
  margin: 15px;
}
.pub_left1 .left-gj .gq li {
  float: left;
  display: inline;
  width: 160px;
  padding-bottom: 20px;
  text-align: left;
  margin-left: 15px;
}
.pub_left1 .left-gj .gq li a {
  color: #333;
  font-size: 15px;
  font-weight: bold;
}
.pub_left1 .left-gj .gq li a:hover {
  color: #c00;
}

.pub_left2 {
  position: relative;
  font-family: "Microsoft Yahei", "微软雅黑", "宋体", Tahoma, Arial, Helvetica,
    STHeiti;
  float: left;
  width: 810px;
}
.pub_left2 .left-gj {
  margin-top: 15px;
}
.pub_left2 .left-gj .letter {
  text-align: left;
  width: 810px;
  z-index: 100;
  height: 50px;
}
.pub_left2 .left-gj .letter ul li {
  float: left;
  line-height: 50px;
  width: 38px;
  *width: 21px;
}
.pub_left2 .left-gj .letter .card {
  background: url(../../assets/imgs/tu7.gif) no-repeat bottom;
  position: relative;
  height: 14px;
  width: 16px;
  clear: both;
  bottom: 13px;
  *bottom: 12px;
  padding-left: 40px;
}
.pub_left2 .left-gj .letter a {
  padding-left: 23px;
  font-size: 17px;
  color: #333;
}
.pub_left2 .left-gj .letter a:hover {
  color: #c33;
}

.pub_left2 .left-gj .gq {
  height: 100px;
  width: 100%;
  border: #c4dcf1 2px solid;
  margin-bottom: 15px;
}
.pub_left2 .left-gj .ss {
  border: #c4dcf1 2px solid;
  padding: 10px;
}
.pub_left2 .left-gj .ss a {
  color: #333;
  font-weight: bold;
  font-size: 15px;
  width: 100px;
  height: 30px;
  line-height: 35px;
  padding: 23px;
}
.pub_left2 .left-gj .ss a:hover {
  color: #c00;
}
.pub_left2 .left-gj .gq img {
  border: #ebebeb 1px solid;
}
.pub_left2 .left-gj .gq ul {
  margin: 15px;
}
.pub_left2 .left-gj .gq li {
  float: left;
  display: inline;
  width: 140px;
  padding-bottom: 20px;
  text-align: left;
  margin-left: 15px;
}
.pub_left2 .left-gj .gq li a {
  color: #333;
  font-size: 15px;
  font-weight: bold;
}
.pub_left2 .left-gj .gq li a:hover {
  color: #c00;
}

.Country .name {
  text-align: left;
  margin-top: 20px;
  width: 100%;
  border-bottom: 2px #555555 solid;
  margin-bottom: 20px;
}
.Country .name .name_z {
  font-size: 23px;
  font-weight: bold;
}
.Country .name .name_d {
  font-size: 32px;
  margin-left: 5px;
  color: #888b8e;
}
.Country .name .name_s {
  font-size: 23px;
  color: #a9aaac;
}
.Country .name img {
  margin-right: 10px;
  margin-bottom: 8px;
}
.Country .tp_left {
  float: left;
  margin-right: 20px;
  text-align: left;
  width: 220px;
}
.Country .js_right1 {
  width: 100%;
  float: right;
}
.Country .js_right1 p {
  color: #727272;
  line-height: 24px;
  font-size: 14px;
}
.Country .js_right {
  width: 490px;
  float: right;
}
.Country .js_right p {
  color: #727272;
  line-height: 24px;
  height: 188px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  overflow: hidden;
}
.Country .js_right2 {
  margin: 10px 0px;
}
.Country .js_right2 li {
  float: left;
  padding: 5px;
  font-size: 15px;
}
.Country .js_right2 li a {
  color: #012f9e;
}
.Country .js_right2 li a:hover {
  color: #c00;
  text-decoration: none;
}

.morebt {
  overflow: hidden;
  _zoom: 1;
  padding: 20px 0 0 0;
}
.morebt ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
}
.morebt ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}

.morebt1 {
  margin-top: 30px;
  overflow: hidden;
  _zoom: 1;
}
.morebt1 ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 35px;
  height: 35px;
}
.morebt1 ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}

.tab0 {
  background: #fff url(../../assets/imgs/bgnav.jpg) repeat-x;
  font-weight: 700;
  overflow: hidden;
  border: 1px #1573b4 solid;
  border-bottom: none;
  position: relative;
  bottom: -1px;
  font-size: 14px;
  color: #fff;
}
.tab1 {
  background: #f4fbff url(../../assets/imgs/bg_nav2.jpg) repeat-x bottom;
  border: 1px #bed9f0 solid;
  border-bottom: none;
  font-size: 14px;
  color: #0561a2;
  height: 32px;
  overflow: hidden;
}
.card_b .main1 {
  border: #c2dbf2 1px solid;
  border-top: 2px #c2dbf2 solid;
  min-height: 850px;
}
.card_b .main1 .pub_content {
  padding: 20px;
  *padding: 0;
  *margin: 20px;
}
.card_b .main1 .extra li {
  font-size: 13px;
  float: left;
  padding-right: 10px;
  color: #333;
  line-height: 22px;
}
.card_b .main1 .list a {
  color: #1c4199;
  font-size: 16px;
}

.pub_right1 {
  width: 367px;
  float: right;
  margin-top: 20px;
  z-index: 1000;
}
.pub_right1 .pub_wz {
  padding: 10px 30px 10px 30px;
}
.pub_right1 .pub_wz a {
  color: #1c4199;
  font-size: 16px;
}
.pub_right1 .pub_wz a:hover {
  color: #c00;
}
.pub_right1 .pub_wz .date1 {
  float: right;
  font-size: 12px;
  color: #666;
}
.pub_right1 .pub_wz p {
  margin-top: 5px;
}

.countryP {
  text-indent: 2em;
}

.zdbg {
  background: #ebebeb none repeat scroll 0% 0%;
  height: 1285px;
}

.zdbg li {
  margin-top: 10px;
}

.pub_left .h1_a ul {
  width: 292px;
  padding: 0 0px 25px 0px;
  text-align: center;
  background-color: #ebebeb;
}

.pub_left .h1_a ul li {
  position: relative;
  margin-bottom: 10px;
  line-height: 40px;
  font-size: 16px;
  margin-right: 10px;
  text-align: left;
  width: 291px;
  cursor: default;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  // background-color: #fff;
}

.pubright {
  float: left;
  width: 610px;
  margin-left: 15px;
}
//location导航
.el-breadcrumb {
  font-size: 15px;
  line-height: 30px;
  margin-left: 20px;
}

//分页
.el-pagination {
  font-weight: normal;
}
//项目栏目-搜索框
.elselect {
  width: 250px;
  margin-top: 10px;
}
.eloption {
  margin-left: 15px;
}

/*--------------------------------------园区-----------------------------------*/

.pub_right2 .location {
  color: #333;
}
.location1 .location {
  color: #333;
}

.pub_right2 {
  float: left;
  width: 610px;
  margin-left: 15px;
}
.pub_right2 .pub_content .list {
  padding: 0 15px 20px 15px;
}
.pub_right2 .abstract {
  line-height: 25px;
  font-size: 14px;
}
.pub_right2 .pub_content .list li .extra {
  font-size: 13px;
  margin: 5px 0px;
}
.pub_right2 .pub_content .list a {
  font-size: 16px;
  text-decoration: none;
  float: left;
}
.pub_right2 .pub_content .list a span {
  color: #1c4199;
}
.pub_right2 .pub_content .list li .extra li {
  float: left;
  color: #666;
  margin-right: 20px;
}
.pub_right2 .pub_content .list li .extra .author {
  margin: 0px 5px;
  color: #9b1111;
}
.pub_right2 .pub_content {
  margin-top: 28px;
  font-size: 14px;
  border-bottom: #ccc 1px dotted;
}

.boxright3 {
  width: 240px;
}
/*background-color:#F1F1F1; height:1300px; overflow:auto; white-space:nowrap*/
.right3 ul li a {
  color: #1c4199;
  font-family: "微软雅黑", "Microsoft YaHei";
}
.right3 ul li {
  line-height: 30px;
  float: left;
  font-size: 14px;
}
.right3 ul {
  padding-left: 15px;
  padding-top: 20px;
}

.mianbox .map .icon1 {
  position: absolute;
  font-size: 13px;
  left: 650px;
  top: 30px;
}
.mianbox .map .icon2 {
  position: absolute;
  font-size: 13px;
  left: 755px;
  top: 350px;
}
.mianbox .map .icon3 {
  position: absolute;
  font-size: 13px;
  left: 760px;
  top: 285px;
}
.mianbox .map .icon4 {
  position: absolute;
  font-size: 13px;
  left: 720px;
  top: 310px;
}
.mianbox .map .icon5 {
  position: absolute;
  font-size: 13px;
  left: 520px;
  top: 235px;
}
.mianbox .map .icon6 {
  position: absolute;
  font-size: 13px;
  left: 270px;
  top: 260px;
}
.mianbox .map .icon7 {
  position: absolute;
  font-size: 13px;
  left: 210px;
  top: 80px;
}
.mianbox .map .icon8 {
  position: absolute;
  font-size: 13px;
  left: 770px;
  top: 325px;
}
.mianbox .map .icon9 {
  position: absolute;
  font-size: 13px;
  left: 280px;
  top: 60px;
}
.mianbox .map .icon10 {
  position: absolute;
  font-size: 13px;
  left: 560px;
  top: 140px;
}
.mianbox .map .icon11 {
  position: absolute;
  font-size: 13px;
  left: 940px;
  top: 290px;
}
.mianbox .map .icon12 {
  position: absolute;
  font-size: 13px;
  left: 270px;
  top: 20px;
}
.mianbox .map .icon13 {
  position: absolute;
  font-size: 13px;
  left: 740px;
  top: 390px;
}
.mianbox .map .icon14 {
  position: absolute;
  font-size: 13px;
  left: 225px;
  top: 125px;
}
.mianbox .map .icon15 {
  position: absolute;
  font-size: 13px;
  left: 450px;
  top: 300px;
}
.mianbox .map .icon16 {
  position: absolute;
  font-size: 13px;
  left: 360px;
  top: 270px;
}
.mianbox .map .icon17 {
  position: absolute;
  font-size: 13px;
  left: 250px;
  top: 100px;
}
.mianbox .map .icon18 {
  position: absolute;
  font-size: 13px;
  left: 1050px;
  top: 333px;
}
.mianbox .map .icon19 {
  position: absolute;
  font-size: 13px;
  left: 590px;
  top: 290px;
}
.mianbox .map .icon20 {
  position: absolute;
  font-size: 13px;
  left: 500px;
  top: 80px;
}

.mianbox .map ul {
  background: #fff;
  padding: 10px;
  border: 1px solid #2b66af;
  z-index: 300;
  position: relative;
  max-height: 300px;
  overflow: auto;
  width: 260px;
  white-space: nowrap;
}
.mianbox .map a {
  z-index: 100;
  position: relative;
}

.pub_content p {
  font-size: 14px;
  line-height: 25px;
}
.pub_wz p {
  font-size: 14px;
  line-height: 25px;
}

/*右侧菜单新增样式2016-12-28*/
.morebt2 {
  margin-top: 10px;
  overflow: hidden;
  _zoom: 1;
  border-bottom: 2px solid #1573b4;
}
.morebt2 ul li {
  float: left;
  margin-right: 8px;
  cursor: pointer;
  line-height: 30px;
  height: 30px;
}
.morebt2 ul li a {
  text-align: center;
  display: block;
  padding: 0 15px;
}
.boxright3 .right3 .yqlist {
  width: 225px;
  background-color: #f1f1f1;
  height: 1000px;
  overflow: auto;
  white-space: nowrap;
  padding-top: 10px;
}

//点左导航的li时更改样式
// .el-menu-item.is-active {
//   background-color: #185bb0 !important;
//   * {
//     color: #fff;
//   }
// }

.pub_left .h1_a ul div .el-menu-item:hover {
  // background-color: #fff;
  * {
    color: #193d8a;
    text-decoration: underline;
  }
}
.pub_left .h1_a ul div .el-submenu :hover {
  // background-color: #fff !important;
}
.pub_left .h1_a ul div .el-submenu .router-link-active:hover {
  color: #193d8a;
  text-decoration: underline;
}
.router-link-exact-active .router-link-active .or {
  background-color: #185bb0;
  color: #fff;
}

.el-menu--inline li {
  background-color: #ebebeb;
}

.mianbox .pub_left .left-nav .nLi .or_a li:hover {
  background-color: #ebebeb;
  * {
    text-decoration: underline;
    color: #c30;
  }
}

//左侧二级菜单点击中
// .or_a .router-link-exact-active {
//   color: #1c4199 !important;
// }
// .temp800407a {
//   padding-left: 20px !important;

//   //margin-left：20px !important;
// }
// .temp800407a2 {
//   padding-left: 80px !important;
// }

/deep/.is-active {
  height: 40px;
  background-color: #185bb0 !important;
  /deep/a {
    color: #fff !important;
  }
}

.is-opened {
  // /deep/a {
  //   color: #fff !important;
  // }
  /deep/.el-menu--inline .is-active {
    background-color: #ebebeb !important;
  }
  /deep/.el-menu--inline .is-active a {
    color: #1c4199 !important;
  }
  /deep/.el-menu--inline a {
    color: #000 !important;
  }
}
// .is-opened :hover{
//  background-color: #185bb0 !important;
// }

.el-submenu {
  background-color: #fff;
  height: 40px;
}

//自己写的样式
//左侧导航
.el-submenu__title * {
  vertical-align: inherit;
}

.el-menu-item,
/deep/.el-submenu__title {
  height: 40px !important;
  line-height: 40px;
}

.el-menu-item a {
  font-size: 16px;
  color: #193d8a;
  padding-left: 60px;
}

.el-menu-item {
  background-color: #fff;
}

.el-submenu__title a {
  font-size: 16px;
  color: #193d8a;
  padding-left: 60px;
}

/deep/.el-menu--inline {
  background-color: #ebebeb !important;
}
.submenu {
  color: #000 !important;
  height: 30px !important;
  line-height: 30px !important;
  font-size: 14px !important;
  padding-left: 10px !important;
  margin-left: 40px !important;
}

/deep/.submenuitem:hover {
  // background-color: #ebebeb !important;
  .submenu {
    color: #c30 !important;
  }
}
//左侧菜单儿子显示隐藏
.or_a_isshow {
  // display: none;
}
</style>
